import script from "./PostSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./PostSlider.vue?vue&type=script&setup=true&lang=js"

import "./PostSlider.vue?vue&type=style&index=0&id=35f9fb24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f9fb24"]])

export default __exports__